import './Filters.scss';

import React, { useEffect } from 'react';
import moment from 'moment';
import Filter from './Filter';
import DateFilter from './DateFilter';
import { fetchUnits, fetchSystems, fetchCommodities, fetchLocations, fetchPriorities, setSelectedUnit, setSelectedDeviceGroup,
  setSelectedAttribute, setSelectedSystem, setSelectedCommodity, setSelectedLocation, setSelectedPriority, setSelectedController, setSelectedDeadLeg } from 'src/module/filter/action';
import { getUnits, getSystems, getCommodities, getLocations, getPriorities, getSelectedDeviceGroup,
  getSelectedAttribute, getDeviceGroups } from 'src/module/filter/selector';
import { shouldUseChemelexUi } from 'src/module/authentication/chemelexUi.selector';
import { getSelectedUnit, getSelectedSystem, getSelectedCommodity, getSelectedLocation, getSelectedPriority, getSelectedController, getSelectedDeadLeg } from 'src/module/filter/selector';
import { fromJS } from 'immutable';

import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { fetchDeviceGroupsLabels } from 'src/module/groupDevices/action';

interface FiltersProps {
  showUnit?: boolean;
  startDate?: moment.Moment | null;
  endDate?: moment.Moment | null;
  onStartDateChange?: (date: moment.Moment | null) => void;
  onEndDateChange?: (date: moment.Moment | null) => void;
}

export default function Filters (props: FiltersProps) {
  const {
    showUnit,
    startDate,
    endDate,
    onStartDateChange,
    onEndDateChange,
  } = props;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchUnits());
    dispatch(fetchSystems());
    dispatch(fetchCommodities());
    dispatch(fetchLocations());
    dispatch(fetchPriorities());
    dispatch(fetchDeviceGroupsLabels());
  }, []);

  const units = useSelector(getUnits);
  const systems = useSelector(getSystems);
  const commodities = useSelector(getCommodities);
  const locations = useSelector(getLocations);
  const priorities = useSelector(getPriorities);
  const groups: any = useSelector(getDeviceGroups);

  const selectedUnit = useSelector(getSelectedUnit);
  const selectedSystem = useSelector(getSelectedSystem);
  const selectedCommodity = useSelector(getSelectedCommodity);
  const selectedLocation = useSelector(getSelectedLocation);
  const selectedPriority = useSelector(getSelectedPriority);
  const selectedController = useSelector(getSelectedController);
  const selectedDeadLeg = useSelector(getSelectedDeadLeg);
  const selectedDeviceGroup = useSelector(getSelectedDeviceGroup);
  const selectedAttribute = useSelector(getSelectedAttribute);
  /* Only the v2 dashboard's summary bar sets this, so the chip has nothing to
   * show -- and no way to have been set -- on the old UI. */
  const useChemelexUi = useSelector(shouldUseChemelexUi);

  const deadLegs = fromJS([{ 'dead leg': 'Yes' }, { 'dead leg': 'No' }, { 'dead leg': null }]);
  /* Raw API values -- Filter maps them to display labels via optionLabelKeys. */
  const attributes = fromJS([
    { attribute: 'offline' }, { attribute: 'alarming' },
    { attribute: 'forcedOn' }, { attribute: 'loto' }, { attribute: null }
  ]);

  return (
    <div className='filters-container'>
      <Filter type='priority' value={selectedPriority} options={priorities} onChange={setSelectedPriority}/>
      <Filter type='commodity' value={selectedCommodity} options={commodities} onChange={setSelectedCommodity}/>
      <Filter type='location' value={selectedLocation} options={locations} onChange={setSelectedLocation}/>
      {showUnit ? <Filter type='unit' value={selectedUnit} options={units} onChange={setSelectedUnit} /> : ''}
      <Filter type='system' value={selectedSystem} options={systems} onChange={setSelectedSystem}/>
      <Filter type='controller' value={selectedController} options={[]} onChange={setSelectedController} />
      <Filter type='dead leg' value={selectedDeadLeg} options={deadLegs} onChange={setSelectedDeadLeg} />
      <Filter type='device_group' value={selectedDeviceGroup} options={groups} onChange={setSelectedDeviceGroup} />
      {useChemelexUi ? <Filter type='attribute' value={selectedAttribute} options={attributes} onChange={setSelectedAttribute} /> : ''}
      {onStartDateChange && (
        <DateFilter type='startDate' value={startDate ?? null} onChange={onStartDateChange} minDate={endDate ? endDate.clone().subtract(2, 'years') : undefined} maxDate={endDate ?? undefined} />
      )}
      {onEndDateChange && (
        <DateFilter type='endDate' value={endDate ?? null} onChange={onEndDateChange} minDate={startDate ?? undefined} />
      )}
    </div>
  );
}


Filters.propTypes = {
  showUnit: PropTypes.bool,
};

Filters.defaultProps = {
  showUnit: true,
  startDate: null,
  endDate: null,
  onStartDateChange: null,
  onEndDateChange: null,
};
